module.exports = __webpack_public_path__ + "static/bp1-57c6c5112992bcabdb67df331cc77365.jpg";